import React, { createContext, useContext, useEffect, useState } from "react";
import localStorageKey from "../enumerations/localStorageKey";

const ShoppingCartContext = createContext({
  cartCount: 0,
  setCartCount: (val: number) => {},
  updateCart: (id: number, count: number) => {},
});

export const ShoppingCartContextProvider = ({
  children,
}: {
  children: React.ReactNode;
}) => {
  const [cartCount, setCartCount] = useState(0);

  const setLocalCart = (val: string) => {
    window.localStorage.setItem(localStorageKey.CART, val);
  };

  const updateTotalCartCount = (cartArr = []) => {
    const totalCount: any = cartArr?.reduce(function (
      acc: number,
      obj: { id: number; quantity: number }
    ) {
      return acc + obj?.quantity;
    },
    0);

    return setCartCount(totalCount ?? 0);
  };

  const reduceCart = (id: number, count: number) => {
    if (!id || !count) return;

    const localCart = localStorage.getItem(localStorageKey.CART);

    if (localCart && JSON.parse(localCart)) {
      const originCart = JSON.parse(localCart);

      if (Array.isArray(originCart) && originCart.length > 0) {
        const foundIndex = originCart.findIndex(
          (item: { id: number; quantity: number }) => {
            return item.id === id;
          }
        );

        if (foundIndex >= 0) {
          const newCart: any = [...originCart];
          const productObj = originCart[foundIndex];
          const newQuantity = productObj.quantity + count;

          if (newQuantity <= 0) {
            newCart.splice(foundIndex, 1);
          } else {
            newCart[foundIndex].quantity = newQuantity;
          }

          updateTotalCartCount(newCart);
          setLocalCart(JSON.stringify(newCart));
        }
      }
    }
  };

  const addToCart = (id: number, count: number) => {
    if (!id || !count) return;
    const localCart = localStorage.getItem(localStorageKey.CART);
    if (localCart && JSON.parse(localCart)) {
      const originCart = JSON.parse(localCart);
      // console.log("typeof originCart", typeof originCart);
      // console.log("originCart", originCart);
      if (typeof originCart === "object" && originCart?.length > 0) {
        // console.log("hi 1");
        // console.log("id", id);
        const foundIndex = originCart?.findIndex(
          (item: { id: number; quantity: number }) => {
            // console.log(item?.id, id);
            return item?.id === id;
          }
        );
        // console.log("foundIndex", foundIndex);
        if (foundIndex >= 0) {
          const newCart = JSON.parse(JSON.stringify(originCart));
          const productObj = originCart[foundIndex];
          const newObj = {
            ...productObj,
            quantity: productObj?.quantity + count,
          };
          newCart.splice(foundIndex, 1, newObj);
          updateTotalCartCount(newCart);
          setLocalCart(JSON.stringify(newCart));
        } else {
          const newCart = JSON.parse(JSON.stringify(originCart));
          newCart.push({ id: id, quantity: count });
          updateTotalCartCount(newCart);
          setLocalCart(JSON.stringify(newCart));
        }
      } else {
        setCartCount(count);
        setLocalCart(JSON.stringify([{ id: id, quantity: count }]));
      }
    } else {
      setCartCount(count);
      setLocalCart(JSON.stringify([{ id: id, quantity: count }]));
    }
  };

  const updateCart = (id: number, count: number) => {
    if (count > 0) {
      addToCart(id, count);
    } else if (count < 0) {
      reduceCart(id, count);
    }
  };

  useEffect(() => {
    const localCart = window.localStorage.getItem(localStorageKey.CART);
    if (localCart) {
      updateTotalCartCount(JSON.parse(localCart));
    }
  }, []);

  return (
    <ShoppingCartContext.Provider
      value={{ cartCount, setCartCount, updateCart }}
    >
      {children}
    </ShoppingCartContext.Provider>
  );
};

export const useShoppingCart = () => {
  const LoadingValue = useContext(ShoppingCartContext);
  return LoadingValue;
};
